import React from 'react';
import PropTypes from 'prop-types';

import content from '../../components/content/Content.m.sass';

import {connect} from 'react-redux';
import {fetchPage} from '../../ducks/pages';

import BreadcrumbsContainer from '../breadcrumbsContainer/BreadcrumbsContainer';
import MenuContainer from '../menuContainer/MenuContainer';
import RawHtml from '../../components/rawHtml/RawHtml';
import GoBack from '../../components/goBack/GoBack';
import Content from '../../components/content/Content';
import withMediaQueries from '../withMediaQueries/withMediaQueries';
import TrustPilot from '../../components/trustPilot/TrustPilot';
import OnlineSupport from '../../components/onlineSupport/OnlineSupport';
import Loader from '../../components/loader/Loader';
import Wysiwyg from "../../components/wysiwyg/Wysiwyg";
import ErrorPage from '../errorPage/ErrorPage';
import Meta from '../../components/meta/Meta';

@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
@connect(({pages}, {params}) => ({page: pages[params.splat]}))
export default class ContentPage extends React.PureComponent {
  static fetchData = ({dispatch, params, page}) => Promise.all([
    ContentPage.fetchPageData({dispatch, params, page}),
    MenuContainer.fetchData({dispatch})
  ]);

  static fetchPageData = ({dispatch, params, page}) =>
    page === undefined && dispatch(fetchPage(params.splat));

  componentDidMount() {
    ContentPage.fetchData(this.props);
  }

  componentDidUpdate() {
    ContentPage.fetchData(this.props);
  }

  render() {
    const {collapsed, page} = this.props;

    if (page === false) {
      return <ErrorPage/>;
    }

    return (
      <div>
        {!!page && (
          <Meta title={page.title}/>
        )}

        {collapsed && (
          <GoBack/>
        )}

        <Content>
          {!collapsed && (
            <div className={content.content_top}>
              <div className="container">
                <BreadcrumbsContainer
                  append={page ? [{name: page.title}] : []}
                  only
                />
              </div>
            </div>
          )}

          <div className="container">
            <div className={content.content_inner}>
              <div className={content.content_row}>
                {!collapsed && (
                  <div className={content.content_sidebar}>
                    <MenuContainer/>
                    <TrustPilot apart/>
                    <OnlineSupport/>
                  </div>
                )}

                {!page ? (
                  <Loader page/>
                ) : (
                  <div className={content.content_full}>
                    <h1 className={content.content_header}>{page.title}</h1>

                    <Wysiwyg>
                      <RawHtml content={page.html}/>
                    </Wysiwyg>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Content>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/contentPage/ContentPage.js